module.exports = __webpack_public_path__ + "static/media/logo-fkh.e9bf1cc5.svg";